import Sample from 'types/models/sample';
import SamplePoint from 'types/models/samplePoint';
import Trigger from 'types/models/trigger';
import { TriggerMessage } from 'types/trigger.enum';

export type EventId = number;

export enum Level {
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
  CRITICAL = 4,
  SOS = 5
}

/**
 * Represents an event object from the MyFarmbot database.
 *
 * Events are typically created by the alert-detector-service and returned
 * by the GET /event endpoint. This type definition excludes some properties
 * that are not utilized by the frontend (type, createdAt, updatedAt).
 */
export type MFBEvent = {
  id: EventId;
  level: Level;
  message: TriggerMessage;
  date: number;
  triggerValue: Trigger['value'];
  triggerId: Trigger['id'];
  samplePointSid: SamplePoint['sid'];
  sampleId: Sample['id'];
  sampleValue: Sample['rwValue'];
};
